import { combineReducers } from "redux";
import { mergeReducers } from "core/redux/decorators";
import * as api from "./api";

const getBookingDetailReducer = mergeReducers(
  api.getBookingDetail.reducer,
  (state = {}, action) => {
    switch (action.type) {
      case api.deleteSubObjective.types.success:
        return {
          ...state,
          data: {
            ...state.data,
            objectives: state.data.objectives.filter(
              o => o.id !== action.payload.request.sub_objective
            )
          }
        };
      default:
        return state;
    }
  }
);

export default combineReducers({
  api: combineReducers({
    getBookingInfo: api.getBookingInfo.reducer,
    deleteSubObjective: api.deleteSubObjective.reducer,
    getBookingDetail: getBookingDetailReducer,
    bookTime: api.bookTime.reducer,
    rescheduleBooking: api.rescheduleBooking.reducer,
    cancelBooking: api.cancelBooking.reducer,
    getBookedCalls: api.getBookedCalls.reducer,
    getBookedCallDetail: api.getBookedCallDetail.reducer,
    getWaitingForFeedbackInsiders: api.getWaitingForFeedbackInsiders.reducer,
    getCallObjectives: api.getCallObjectives.reducer,
    applyPromoCode: api.applyPromoCode.reducer
  })
});



// WEBPACK FOOTER //
// ./src/modules/booking/reducer.js